// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_oj-0";
export var animationContainer = "_oj-1";
export var itemPrice = "_oj-a";
export var itemizedContent = "_oj-9";
export var itemizedHeader = "_oj-7";
export var itemizedRow = "_oj-8";
export var itemizedSection = "_oj-6";
export var modalContent = "_oj-2";
export var orderName = "_oj-3";
export var refundOption = "_oj-4";
export var refundOptionsContainer = "_oj-5";
export var shippingLabel = "_oj-b";
export var totalRow = "_oj-c";